import { ReponseFraisResiliation } from '../../models/reponses/reponse-frais-resiliation';
import { ReponseEnveloppe } from '../../models/reponses/reponse-enveloppe';

export const reponseFraisResiliation: ReponseEnveloppe<ReponseFraisResiliation> = {
    reponse:
        {
            "montant" : 12.888
        }
}
